export default __webpack_public_path__ + "static/profile-pic-96b36043b911b9f260a3a199c56b84fb.png";